var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"inherit","width":"inherit"},attrs:{"id":_vm.call.elIds.main}},[(_vm.call.is_connected)?_c('div',{staticStyle:{"height":"inherit","width":"inherit"}},[_c('Conference',{attrs:{"call":_vm.call}})],1):_c('div',[_c('app-spinner',{staticClass:"big vertically-centered"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }